import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@backslashbuild/pp-ui";
import {
  Content,
  PageTitle,
  PanelColumn,
  PageHeadingArea,
  PanelColumnSet,
} from "@backslashbuild/pp-ui";

import BranchForm from "../modules/agencies/BranchForm";

export default function EditAgencyBranch() {
  const { branchId } = useParams();

  return (
    <Content scrollable>
      <PageHeadingArea>
        <PageTitle>Edit Branch</PageTitle>
      </PageHeadingArea>

      <PanelColumnSet>
        <PanelColumn>
          <BranchForm id={branchId} />
        </PanelColumn>
      </PanelColumnSet>
    </Content>
  );
}
